export type PendingLocationResult =
  | { status: 'success'; latitude: number; longitude: number; accuracy: number }
  | { status: 'error'; error: string };

export type LocationCapabilityCompletion =
  | {
      status: 'success';
      location: {
        latitude: number;
        longitude: number;
        accuracy_m: number;
      };
    }
  | {
      status: 'error';
      error: string;
    };

export function requestGeolocation(): Promise<PendingLocationResult> {
  return new Promise(resolve => {
    if (!navigator.geolocation) {
      resolve({
        status: 'error',
        error: 'Geolocation API is not available in this browser.',
      });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        resolve({
          status: 'success',
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      error => {
        resolve({ status: 'error', error: error.message });
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  });
}

export function locationCompletionFromResult(
  result: PendingLocationResult
): LocationCapabilityCompletion {
  if (result.status === 'success') {
    return {
      status: 'success',
      location: {
        latitude: result.latitude,
        longitude: result.longitude,
        accuracy_m: Math.round(result.accuracy),
      },
    };
  }
  return {
    status: 'error',
    error: result.error,
  };
}
